import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Auth.css';

export default function VerifyEmailPage() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [state, setState] = useState({ status: 'verifying', message: '' });

  useEffect(() => {
    let cancelled = false;
    async function go() {
      if (!token) {
        setState({ status: 'error', message: 'This verification link is incomplete.' });
        return;
      }
      try {
        await verifyEmail(token);
        if (!cancelled) setState({ status: 'success', message: 'Your email is verified. You can now sign in.' });
      } catch (err) {
        if (!cancelled) setState({
          status: 'error',
          message: err?.response?.data?.detail || 'This verification link is invalid or has expired.',
        });
      }
    }
    go();
    return () => { cancelled = true; };
  }, [token, verifyEmail]);

  return (
    <div className="auth-page" data-testid="verify-email-page">
      <Link to="/" className="auth-back">&larr; Back to iCraftz</Link>
      <div className="auth-card">
        <img src="/seal/icraftz-wax-seal-small.png" alt="" className="auth-card-seal" aria-hidden="true" />
        {state.status === 'verifying' && (
          <>
            <h1 className="auth-title">Verifying…</h1>
            <p className="auth-sub">Just a moment while we seal your account.</p>
          </>
        )}
        {state.status === 'success' && (
          <>
            <h1 className="auth-title">Email <span className="auth-title-accent">Verified</span></h1>
            <p className="auth-sub">{state.message}</p>
            <div className="auth-divider"><span className="auth-divider-line" /><span className="auth-divider-mark">❦</span><span className="auth-divider-line" /></div>
            <button
              type="button"
              className="auth-submit"
              onClick={() => navigate('/login', { replace: true })}
              data-testid="verify-goto-login"
            >
              Sign In
            </button>
          </>
        )}
        {state.status === 'error' && (
          <>
            <h1 className="auth-title">Link <span className="auth-title-accent">Expired</span></h1>
            <p className="auth-sub">{state.message}</p>
            <p className="auth-footer">
              <Link to="/signup">Create a new account</Link> or <Link to="/login">try logging in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
